<template>

    <v-select
        v-model="selectedCustomerType"
        :options="customerTypes"
        :clearable="false"
        placeholder="Select a customer type"
        label="name"
    />

    <input type="hidden" name="type" :value="selectedCustomerType ? selectedCustomerType.id : ''">

    <div v-if="errors.length > 0" >
        <div class="alert alert-danger mt-2" role="alert" v-for="(error, index) in errors" :key="index">
            {{ error }}
        </div>
    </div>

</template>

<script>

import VSelect from 'vue-select';

export default {

    props: {
        routes: {
            type: Object,
            required: true
        },
        old: {
            type: String,
            required: false
        },
        value: {
            type: Number,
            required: false
        },
        errors: {
            type: Array,
            required: false
        }
    },

    components: {
        VSelect
    },

    data() {
        return {
            selectedCustomerType: null,
            customerTypes: [
                { id: 0, name: 'Not Assigned' },
                { id: 1, name: 'Pro Forma' },
                { id: 6, name: 'Credit (14 Day)' },
                { id: 2, name: 'Credit (30 Day)' },
                { id: 5, name: 'Credit (45 Day)' },
                { id: 3, name: 'Credit (60 Day)' },
                { id: 4, name: 'On Hold' },
                { id: 7, name: 'End of Month (30 Day)' },
                { id: 8, name: 'End of Month (60 Day)' },
            ],
        }
    },

    methods: {

    },

    created() {

    },

    mounted() {

        // axios.get(this.routes.types)
        //     .then(response => {
        //
        //         let types_array = []
        //
        //         Object.entries( response.data ).forEach( ([, value]) => {
        //             return types_array.push( value );
        //         });
        //
        //         this.customerTypes = types_array;
        //
        //     })
        //     .then(() => {

                this.selectedCustomerType = this.customerTypes[0];

                if (this.value !== null) {
                    this.selectedCustomerType = this.customerTypes.find(type => type.id === this.value);
                }

                // Prioritise Old form data over the value
                if (this.old !== null) {
                    this.selectedCustomerType = this.customerTypes.find(type => type.id === this.old);
                }

            // })
            // .catch(error => {
            //     console.log(error);
            // });

    },

    watch: {

        // selectedCustomerType: function () {
        //     this.selectedCustomerTypeId = this.customerTypes.findIndex(type => type === this.selectedCustomerType );
        // }

    }

}

</script>
